import React from 'react';
import QueueTreatmentContextPropTypes from './QueueTreatmentContextPropTypes';
import queueTreatmentConfig from './QueueTreatmentConfig';

export default React.createContext<QueueTreatmentContextPropTypes>(
  queueTreatmentConfig,
);
